import { useFetchRecipes } from "./assessment";
import useAppContext from "../components/AppContext";
import {
  MULTI_CHOICE_GROUPS,
  DIETARY,
  MULTISELECT_NONE_OF_THESE
} from "../config/tags";

const getCuisines = (answers, questions) => {
  const cuisinesQuestionsIds = questions
    .filter(q => q.tags.includes(MULTI_CHOICE_GROUPS))
    .map(q => q._id);

  const answersCuisineQuestion = answers?.find(a =>
    cuisinesQuestionsIds.includes(a?.questionId)
  );

  const cuisines = [];
  const cuisineTag = (
    questions.find(q => q.tags.includes(MULTI_CHOICE_GROUPS)) || []
  ).answers?.presentationMetadata[0].tags[0];

  for (let i = 0; i < answersCuisineQuestion?.answers.length; i++) {
    if (answersCuisineQuestion?.answers[i].tags.includes(cuisineTag)) {
      cuisines.push(answersCuisineQuestion.answers[i].text);
    }

    if (cuisines.length >= 3) {
      break;
    }
  }

  return cuisines;
};

const getDietaryPreferences = (answers, questions) => {
  const dietaryQuestionsIds = questions
    .filter(q => q.tags.includes(DIETARY))
    .map(q => q._id);

  const answersDietaryQuestion = answers?.find(a =>
    dietaryQuestionsIds.includes(a?.questionId)
  );

  const dietary = [];

  answersDietaryQuestion?.answers.forEach(a => {
    if (!a.tags.includes(MULTISELECT_NONE_OF_THESE)) {
      dietary.push(a.text);
    }
  });

  return dietary;
};

export const useRecipeResults = () => {
  const { assessment, answers } = useAppContext();

  const cuisines = getCuisines(answers, assessment.questions);
  const dietaryPreferences = getDietaryPreferences(
    answers,
    assessment.questions
  );

  const { data, isLoading } = useFetchRecipes(cuisines, dietaryPreferences);

  return { data, isLoading };
};
